import React, { useState, useEffect, useMemo } from "react";
import { Badge, Button, Col, Form, Image, InputGroup, Modal, Row, Table, Nav, Alert, Spinner, Card } from "react-bootstrap";
import { oneKlicks } from '../../SDK/oneclick';
import ImageShow from '../../Uitiles/ImageShow';
import { toast } from 'react-toastify';
import html2canvas from 'html2canvas';

const SalarySheetPreparation = () => {
    const [selectedMonth, setSelectedMonth] = useState(new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit' }));
    const [employeeList, setEmployeeList] = useState([]);
    const [attendanceList, setAttendanceList] = useState([]);
    const [salarySheet, setSalarySheet] = useState([]);
    const [existingSalaryRecords, setExistingSalaryRecords] = useState([]);
    const [loading, setLoading] = useState(false);
    const [generating, setGenerating] = useState(false);
    const [showPreview, setShowPreview] = useState(false);
    const [savingToDatabase, setSavingToDatabase] = useState(false);

    // Modal states
    const [showViewModal, setShowViewModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showPayModal, setShowPayModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [editStatus, setEditStatus] = useState('');
    const [editNotes, setEditNotes] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('');
    const [paymentReference, setPaymentReference] = useState('');
    const [processingPayment, setProcessingPayment] = useState(false);

    // Payslip modal states
    const [showPayslipModal, setShowPayslipModal] = useState(false);
    const [payslipData, setPayslipData] = useState(null);
    const [generatingPayslip, setGeneratingPayslip] = useState(false);

    // Holidays states
    const [holidaysList, setHolidaysList] = useState([]);
    const [holidaysCount, setHolidaysCount] = useState(0);
    const [companyLeaves, setCompanyLeaves] = useState(1.5);
    const [companyHolidays, setCompanyHolidays] = useState([]);
    const [leaveCarryForwardMap, setLeaveCarryForwardMap] = useState({});
    // Generate months dynamically - from 2 years ago to current month
    const generateMonths = () => {
        const months = [];
        const currentDate = new Date();
        const currentYear = currentDate.getFullYear();
        const currentMonth = currentDate.getMonth() + 1; // getMonth() returns 0-11, so add 1

        // Start from 2 years ago
        const startYear = currentYear - 2;

        for (let year = startYear; year <= currentYear; year++) {
            const endMonth = year === currentYear ? currentMonth : 12;

            for (let month = 1; month <= endMonth; month++) {
                const monthValue = `${year}-${month.toString().padStart(2, '0')}`;
                const monthNames = [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ];
                const monthLabel = `${monthNames[month - 1]} ${year}`;

                months.push({
                    value: monthValue,
                    label: monthLabel
                });
            }
        }

        // Sort in descending order (most recent first)
        return months.reverse();
    };

    const months = generateMonths();

    useEffect(() => {
        fetchExistingSalaryRecords();
    }, []);

    useEffect(() => {
        fetchEmployeeList();
        fetchAttendanceForMonth();
        fetchExistingSalaryRecords();
        fetchHolidaysList();
        fetchPreviousCarryForwardMap();
    }, [selectedMonth]);

    // Holidays Functions
    const fetchHolidaysList = async () => {
        console.log("fetchHolidaysList selectedMonth :", selectedMonth);
        const [year, month] = selectedMonth.split('-');
        setLoading(true);
        try {
            const tableSchema = '';
            const tableName = 'holidays';
            const conditions = {
                "date": { "start": `${year}-${month}-01`, "end": `${year}-${month}-31` }  //{ "start": 20, "end": 30 },
            };
            const orderBy = 'date ASC';
            const search = {};
            const pagination = {};
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            console.log("holidays response data :", response.data);
            if (response.success) {
                console.log("holidays response data :", response.data);
                setHolidaysList(response.data);
                setHolidaysCount(response.data.length);
                setCompanyHolidays(response.data.filter(holiday => holiday.type === 'company'));
                console.log("holidaysCount :", holidaysCount);
            } else {
                toast.error('Failed to fetch holidays list');
            }
        } catch (error) {
            console.error('holidays fetchHolidaysList Error fetching holidays:', error);
            toast.error('Error fetching holidays list');
        } finally {
            setLoading(false);
        }
    };

    const fetchEmployeeList = async () => {
        try {
            const tableSchema = '';
            const tableName = 'employees';
            const conditions = {
                status: 'active'
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [
                {
                    target_table: 'users',
                    target_column: 'id',
                    target_value: 'staff_id',
                    target_label: 'staff'
                }
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.success) {
                setEmployeeList(response.data);
            }
        } catch (error) {
            console.error('Error fetching employee list:', error);
        }
    };

    const fetchAttendanceForMonth = async () => {
        setLoading(true);
        try {
            const [year, month] = selectedMonth.split('-');
            console.log("fetchAttendanceForMonth selectedMonth :", selectedMonth);
            const tableSchema = '';
            const tableName = 'attendance';
            const conditions = {
                "date": { "start": `${year}-${month}-01`, "end": `${year}-${month}-31` }  //{ "start": 20, "end": 30 },
            };
            const orderBy = 'id DESC';
            const search = {};
            console.log("fetchAttendanceForMonth conditions :", conditions);
            const pagination = {};
            const margedata = [
                {
                    target_table: 'employees',
                    target_column: 'id',
                    target_value: 'employee_id',
                    target_label: 'employee',
                    margedata: [
                        {
                            target_table: 'users',
                            target_column: 'id',
                            target_value: 'staff_id',
                            target_label: 'staff'
                        }
                    ]
                }
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);
            if (response.success) {
                console.log("attendance response data :", response.data);
                setAttendanceList(response.data);
            }
        } catch (error) {
            console.error('Error fetching attendance:', error);
            toast.error('Error fetching attendance data');
        } finally {
            setLoading(false);
        }
    };

    const fetchExistingSalaryRecords = async () => {
        try {
            const [year, month] = selectedMonth.split('-');
            const monthName = months.find(m => m.value === selectedMonth)?.label?.split(' ')[0];

            const tableSchema = '';
            const tableName = 'salary_payments';
            const conditions = {
                date: { "start": `${year}-${month}-01`, "end": `${year}-${month}-31` }  //{ "start": 20, "end": 30 },
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [
                {
                    target_table: 'employees',
                    target_column: 'id',
                    target_value: 'staff_id',
                    target_label: 'employee',
                    margedata: [
                        {
                            target_table: 'users',
                            target_column: 'id',
                            target_value: 'staff_id',
                            target_label: 'staff'
                        }
                    ]
                }
            ];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            console.log("salary sheet response data :", response.data);
            if (response.success) {
                setExistingSalaryRecords(response.data);
            }
        } catch (error) {
            console.error('Error fetching existing salary records:', error);
        }
    };

    const fetchPreviousCarryForwardMap = async () => {
        try {
            if (!selectedMonth) {
                setLeaveCarryForwardMap({});
                return;
            }

            const [year, month] = selectedMonth.split('-');
            const currentYear = parseInt(year, 10);
            const currentMonth = parseInt(month, 10);

            if (isNaN(currentYear) || isNaN(currentMonth)) {
                setLeaveCarryForwardMap({});
                return;
            }

            const previousMonthDate = new Date(currentYear, currentMonth - 2, 1);
            const previousYear = previousMonthDate.getFullYear();
            const previousMonthName = previousMonthDate.toLocaleString('default', { month: 'long' });

            const tableSchema = '';
            const tableName = 'salary_payments';
            const conditions = {
                year: previousYear,
                month: previousMonthName
            };
            const orderBy = 'id DESC';
            const search = {};
            const pagination = {};
            const margedata = [];

            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata);

            if (response.success) {
                const carryForwardData = {};
                response.data.forEach(record => {
                    if (record.staff_id && carryForwardData[record.staff_id] === undefined) {
                        carryForwardData[record.staff_id] = parseFloat(record.leave_carry_forward) || 0;
                    }
                });
                setLeaveCarryForwardMap(carryForwardData);
            } else {
                setLeaveCarryForwardMap({});
            }
        } catch (error) {
            console.error('Error fetching previous leave carry forward:', error);
            setLeaveCarryForwardMap({});
        }
    };

    const calculateWorkingDays = (year, month) => {
        const daysInMonth = new Date(year, month, 0).getDate();
        let workingDays = 0;

        for (let day = 1; day <= daysInMonth; day++) {
            const date = new Date(year, month - 1, day);
            const dayOfWeek = date.getDay();
            // Count Monday to Friday as working days
            if (dayOfWeek >= 1 && dayOfWeek <= 5) {
                workingDays++;
            }
        }

        return workingDays;
    };

    const calculateEmployeeAttendance = (employeeId) => {
        const [year, month] = selectedMonth.split('-');
        console.log("employeeAttendance year :", year);
        console.log("employeeAttendance month :", month);
        console.log("employeeAttendance selectedMonth :", attendanceList);
        console.log("employeeAttendance employeeId :", employeeId);
        const employeeAttendance = attendanceList.filter(att => Number(att.employee_id) === Number(employeeId));
        console.log("employeeAttendance :", employeeAttendance);
        const presentDays = employeeAttendance.filter(att => att.status === 'present').length;
        console.log("employeeAttendance presentDays :", presentDays);
        const absentDays = employeeAttendance.filter(att => att.status === 'absent').length;
        console.log("employeeAttendance absentDays :", absentDays);
        const lateDays = employeeAttendance.filter(att => att.status === 'late').length;
        console.log("employeeAttendance lateDays :", lateDays);
        const halfDays = employeeAttendance.filter(att => att.status === 'half_day').length;
        console.log("employeeAttendance halfDays :", halfDays);
        const leaveDays = employeeAttendance.filter(att => att.status === 'leave').length;
        console.log("employeeAttendance leaveDays :", leaveDays);
        const totalWorkingDays = calculateWorkingDays(parseInt(year), parseInt(month));
        console.log("employeeAttendance totalWorkingDays :", totalWorkingDays, year, month);
        const totalDays = presentDays + (halfDays * 0.5);

        console.log("employeeAttendance holidaysCountEmployee :", holidaysCount);

        return {
            presentDays,
            absentDays,
            lateDays,
            halfDays,
            leaveDays,
            totalWorkingDays,
            totalDays,
            holidaysCount,
            attendancePercentage: totalWorkingDays > 0 ? (((totalDays - holidaysCount) / totalWorkingDays) * 100).toFixed(1) : 0
        };
    };

    const generateSalarySheet = async () => {
        setGenerating(true);
        console.log('Generating salary sheet');
        console.log("selectedMonth", selectedMonth);
        try {
            const [year, month] = selectedMonth.split('-');
            const salarySheetData = [];
            console.log("year", year);
            console.log("month", month);

            const daysInSelectedMonth = new Date(parseInt(year, 10), parseInt(month, 10), 0).getDate();

            for (const employee of employeeList) {
                const attendance = calculateEmployeeAttendance(employee.id);
                const baseSalary = parseFloat(employee.base_salary) || 0;
                const allowances = parseFloat(employee.allowances) || 0;
                const deductions = parseFloat(employee.deductions) || 0;

                // Calculate salary based on attendance and paid leave allowance
                const dailySalary = daysInSelectedMonth > 0 ? baseSalary / daysInSelectedMonth : 0;
                console.log("generateSalarySheet dailySalary :", dailySalary, employee.employee_id);

                const baseMonthlyAllowance = Number(companyLeaves) || 0;
                const previousCarryForward = parseFloat(leaveCarryForwardMap[employee.employee_id]) || 0;
                const monthlyLeaveAllowance = baseMonthlyAllowance + previousCarryForward;
                const paidLeaveDays = Math.min(attendance.leaveDays, monthlyLeaveAllowance);
                const unpaidLeaveDays = Math.max(attendance.leaveDays - paidLeaveDays, 0);
                const leaveCarryForward = Math.max(monthlyLeaveAllowance - paidLeaveDays, 0);

                const unpaidHalfDays = attendance.halfDays * 0.5;
                const unpaidAbsences = attendance.absentDays;
                const totalUnpaidDays = unpaidLeaveDays + unpaidAbsences + unpaidHalfDays;

                const payableDays = Math.max(daysInSelectedMonth - totalUnpaidDays, 0);
                console.log("generateSalarySheet payableDays :", payableDays, employee.employee_id);
                const earnedSalary = dailySalary * payableDays;
                console.log("generateSalarySheet earnedSalary :", earnedSalary, employee.employee_id);
                console.log("generateSalarySheet paidLeaveDays :", paidLeaveDays, employee.employee_id);
                console.log("generateSalarySheet unpaidLeaveDays :", unpaidLeaveDays, employee.employee_id);
                console.log("generateSalarySheet leaveCarryForward :", leaveCarryForward, employee.employee_id);
                console.log("generateSalarySheet previousCarryForward :", previousCarryForward, employee.employee_id);
                console.log("generateSalarySheet unpaidAbsences :", unpaidAbsences, employee.employee_id);
                console.log("generateSalarySheet unpaidHalfDays :", unpaidHalfDays, employee.employee_id);
                console.log("generateSalarySheet totalUnpaidDays :", totalUnpaidDays, employee.employee_id);

                // Calculate overtime if applicable
                const overtimeHours = attendanceList
                    .filter(att => att.employee_id === employee.id && att.overtime_hours)
                    .reduce((sum, att) => sum + parseFloat(att.overtime_hours), 0);

                const overtimeRate = dailySalary / 8; // Assuming 8 hours per day
                const overtimePay = overtimeHours * overtimeRate;

                // Calculate total earnings
                const totalEarnings = earnedSalary + allowances + overtimePay;
                const netSalary = totalEarnings - deductions;

                salarySheetData.push({
                    employee_id: employee.id,
                    employee_name: `${employee.staff?.[0]?.first_name} ${employee.staff?.[0]?.last_name}`,
                    employee_code: employee.employee_id,
                    department: employee.department,
                    designation: employee.designation,
                    profile_photo_url: employee.staff?.[0]?.profile_photo_url,
                    base_salary: baseSalary,
                    allowances: allowances,
                    overtime_pay: overtimePay,
                    payable_days: payableDays,
                    paid_leave_days: paidLeaveDays,
                    unpaid_leave_days: unpaidLeaveDays,
                    unpaid_absent_days: unpaidAbsences,
                    unpaid_half_days: unpaidHalfDays,
                    total_unpaid_days: totalUnpaidDays,
                    leave_carry_forward: leaveCarryForward,
                    leave_allowance: monthlyLeaveAllowance,
                    base_leave_allowance: baseMonthlyAllowance,
                    previous_leave_carry_forward: previousCarryForward,
                    total_earnings: totalEarnings,
                    deductions: deductions,
                    net_salary: netSalary,
                    attendance: attendance,
                    overtime_hours: overtimeHours,
                    holidays_count: holidaysCount,
                    month: parseInt(month),
                    year: parseInt(year)
                });

            }

            setSalarySheet(salarySheetData);
            setShowPreview(true);
            toast.success('Salary sheet generated successfully');
        } catch (error) {
            console.error('Error generating salary sheet:', error);
            toast.error('Error generating salary sheet');
        } finally {
            setGenerating(false);
        }
    };

    const exportSalarySheet = () => {
        // Create CSV content
        const csvHeaders = [
            'Employee ID',
            'Employee Name',
            'Department',
            'Designation',
            'Base Salary',
            'Allowances',
            'Overtime Pay',
            'Total Earnings',
            'Deductions',
            'Net Salary',
            'Present Days',
            'Absent Days',
            'Holidays Count',
            'Company Leaves',
            'Attendance %'
        ];

        const csvData = salarySheet.map(emp => [
            emp.employee_code,
            emp.employee_name,
            emp.department,
            emp.designation,
            emp.base_salary.toFixed(2),
            emp.allowances.toFixed(2),
            emp.overtime_pay.toFixed(2),
            emp.total_earnings.toFixed(2),
            emp.deductions.toFixed(2),
            emp.net_salary.toFixed(2),
            emp.attendance.presentDays,
            emp.attendance.absentDays,
            emp.attendance.holidaysCount,
            emp.leave_allowance.toFixed(2),
            emp.attendance.attendancePercentage
        ]);

        const csvContent = [csvHeaders, ...csvData]
            .map(row => row.map(cell => `"${cell}"`).join(','))
            .join('\n');

        // Download CSV
        const blob = new Blob([csvContent], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `salary_sheet_${selectedMonth}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        toast.success('Salary sheet exported successfully');
    };

    const saveSalarySheetToDatabase = async () => {
        if (salarySheet.length === 0) {
            toast.error('No salary sheet data to save');
            return;
        }

        setSavingToDatabase(true);
        try {
            const [year, month] = selectedMonth.split('-');
            const monthName = months.find(m => m.value === selectedMonth)?.label?.split(' ')[0];

            let successCount = 0;
            let errorCount = 0;

            for (const employee of salarySheet) {
                try {
                    // Check if record already exists
                    const existingRecord = existingSalaryRecords.find(
                        record => record.staff_id === employee.employee_id

                    );

                    const salaryData = {
                        staff_id: employee.employee_id,
                        amount: employee.net_salary,
                        month: monthName,
                        overtime_hours: employee.overtime_hours,
                        overtime_pay: employee.overtime_pay,
                        total_earnings: employee.total_earnings,
                        deductions: employee.deductions,
                        net_salary: employee.net_salary,
                        attendance: JSON.stringify(employee.attendance),
                        payable_days: employee.payable_days,
                        paid_leave_days: employee.paid_leave_days,
                        unpaid_leave_days: employee.unpaid_leave_days,
                        unpaid_absent_days: employee.unpaid_absent_days,
                        unpaid_half_days: employee.unpaid_half_days,
                        total_unpaid_days: employee.total_unpaid_days,
                        leave_allowance: employee.leave_allowance,
                        base_leave_allowance: employee.base_leave_allowance,
                        previous_leave_carry_forward: employee.previous_leave_carry_forward,
                        leave_carry_forward: employee.leave_carry_forward,
                        year: parseInt(year),
                        transfer_method: 'salary_sheet_generated',
                        reference_number: `SHEET-${selectedMonth}-${employee.employee_id}`,
                        status: 'pending',
                        notes: `Salary sheet generated for ${months.find(m => m.value === selectedMonth)?.label} - Base: ${formatCurrency(employee.base_salary)}, Allowances: ${formatCurrency(employee.allowances)}, Deductions: ${formatCurrency(employee.deductions)}, Attendance: ${employee.attendance?.attendancePercentage || 0}%, Paid Leave: ${employee.paid_leave_days}, Unpaid Leave: ${employee.unpaid_leave_days}, Unpaid Absences: ${employee.unpaid_absent_days}, Unpaid Half Days: ${employee.unpaid_half_days}, Previous Carry: ${employee.previous_leave_carry_forward}, Carry Forward: ${employee.leave_carry_forward}`
                    };

                    const tableSchema = '';
                    const tableName = 'salary_payments';

                    if (existingRecord) {
                        // Update existing record
                        const conditions = { id: existingRecord.id };
                        const response = await oneKlicks.update(tableSchema, tableName, salaryData, conditions);
                        if (response.success) {
                            successCount++;
                        } else {
                            errorCount++;
                        }
                    } else {
                        // Create new record
                        const conditions = {};
                        const response = await oneKlicks.create(tableSchema, tableName, salaryData, conditions);
                        if (response.success) {
                            successCount++;
                        } else {
                            errorCount++;
                        }
                    }
                } catch (error) {
                    console.error(`Error saving salary for employee ${employee.employee_id}:`, error);
                    errorCount++;
                }
            }

            if (successCount > 0) {
                toast.success(`Successfully saved ${successCount} salary records to database`);
                // Refresh existing records
                await fetchExistingSalaryRecords();
            }

            if (errorCount > 0) {
                toast.warning(`${errorCount} records failed to save. Please check the console for details.`);
            }

        } catch (error) {
            console.error('Error saving salary sheet to database:', error);
            toast.error('Error saving salary sheet to database');
        } finally {
            setSavingToDatabase(false);
        }
    };

    // Modal handler functions
    const handleViewRecord = (record) => {
        setSelectedRecord(record);
        setShowViewModal(true);
    };

    const handleEditRecord = (record) => {
        setSelectedRecord(record);
        setEditStatus(record.status);
        setEditNotes(record.notes || '');
        setShowEditModal(true);
    };

    const handlePayRecord = (record) => {
        setSelectedRecord(record);
        setPaymentMethod('');
        setPaymentReference('');
        setShowPayModal(true);
    };

    const handleUpdateRecord = async () => {
        if (!selectedRecord || !editStatus) {
            toast.error('Please select a status');
            return;
        }

        try {
            const tableSchema = '';
            const tableName = 'salary_payments';
            const conditions = { id: selectedRecord.id };
            const updateData = {
                status: editStatus,
                notes: editNotes,
                updated_at: new Date().toISOString()
            };

            const response = await oneKlicks.update(tableSchema, tableName, updateData, conditions);

            if (response.success) {
                toast.success('Salary record updated successfully');
                setShowEditModal(false);
                await fetchExistingSalaryRecords();
            } else {
                toast.error('Failed to update salary record');
            }
        } catch (error) {
            console.error('Error updating salary record:', error);
            toast.error('Error updating salary record');
        }
    };

    const handleProcessPayment = async () => {
        if (!selectedRecord || !paymentMethod) {
            toast.error('Please select a payment method');
            return;
        }

        if (paymentMethod !== 'cash' && !paymentReference) {
            toast.error('Please enter a reference number for non-cash payments');
            return;
        }

        setProcessingPayment(true);
        try {
            const tableSchema = '';
            const tableName = 'salary_payments';
            const conditions = { id: selectedRecord.id };
            const updateData = {
                status: 'paid',
                transfer_method: paymentMethod,
                reference_number: paymentReference || `CASH-${Date.now()}`,
                notes: `${selectedRecord.notes || ''}\nPayment processed via ${paymentMethod} on ${new Date().toLocaleDateString()}`,
                updated_at: new Date().toISOString()
            };

            const response = await oneKlicks.update(tableSchema, tableName, updateData, conditions);

            if (response.success) {
                toast.success('Payment processed successfully');
                setShowPayModal(false);
                await fetchExistingSalaryRecords();
            } else {
                toast.error('Failed to process payment');
            }
        } catch (error) {
            console.error('Error processing payment:', error);
            toast.error('Error processing payment');
        } finally {
            setProcessingPayment(false);
        }
    };

    // Payslip generation function
    const handlePaySlip = async (record) => {
        setGeneratingPayslip(true);
        try {
            // Find the corresponding employee data
            console.log("handlePaySlip record :", record);
            console.log("handlePaySlip employeeList :", employeeList);
            const employee = employeeList.find(emp => emp.id === record.employee?.[0]?.id);
            console.log("handlePaySlip employee :", employee);
            if (record.employee.length < 0) {
                toast.error('Employee data not found');
                return;
            }

            // Calculate attendance for the month
            const attendance = calculateEmployeeAttendance(record.employee?.[0]?.id);

            // Generate payslip data
            const payslip = {
                employee: {
                    name: `${record.employee?.[0]?.staff?.[0]?.first_name} ${record.employee?.[0]?.staff?.[0]?.last_name}`,
                    id: record.employee?.[0]?.employee_id,
                    department: record.employee?.[0]?.department,
                    designation: record.employee?.[0]?.designation,
                    profile_photo: record.employee?.[0]?.staff?.[0]?.profile_photo_url
                },
                period: {
                    month: record.month,
                    year: record.year,
                    monthName: months.find(m => m.value === selectedMonth)?.label
                },
                salary: {
                    basic: parseFloat(record.base_salary) || 0,
                    allowances: parseFloat(record.allowances) || 0,
                    overtime: parseFloat(record.overtime_pay) || 0,
                    totalEarnings: parseFloat(record.total_earnings) || 0,
                    deductions: parseFloat(record.deductions) || 0,
                    netSalary: parseFloat(record.amount)
                },
                attendance: {
                    presentDays: attendance.presentDays,
                    absentDays: attendance.absentDays,
                    totalWorkingDays: attendance.totalWorkingDays,
                    attendancePercentage: attendance.attendancePercentage
                },
                payment: {
                    method: record.transfer_method,
                    reference: record.reference_number,
                    status: record.status,
                    paidDate: record.updated_at ? new Date(record.updated_at).toLocaleDateString() : null
                },
                generatedDate: new Date().toLocaleDateString(),
                generatedTime: new Date().toLocaleTimeString()
            };

            setPayslipData(payslip);
            setShowPayslipModal(true);
            toast.success('Payslip generated successfully');
        } catch (error) {
            console.error('Error generating payslip:', error);
            toast.error('Error generating payslip');
        } finally {
            setGeneratingPayslip(false);
        }
    };

    const downloadPayslipPDF = async () => {
        if (!payslipData) return;

        try {
            // Find the payslip modal content
            const payslipElement = document.getElementById('payslip-content');
            if (!payslipElement) {
                toast.error('Payslip content not found');
                return;
            }

            // Configure html2canvas options
            const canvas = await html2canvas(payslipElement, {
                scale: 2, // Higher quality
                useCORS: true,
                allowTaint: true,
                backgroundColor: '#ffffff',
                width: payslipElement.scrollWidth,
                height: payslipElement.scrollHeight,
                scrollX: 0,
                scrollY: 0
            });

            // Convert canvas to blob
            canvas.toBlob((blob) => {
                if (blob) {
                    // Create download link
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `payslip_${payslipData.employee.id}_${payslipData.period.month}_${payslipData.period.year}.png`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);

                    toast.success('Payslip downloaded as image successfully');
                } else {
                    toast.error('Failed to generate payslip image');
                }
            }, 'image/png', 0.95);

        } catch (error) {
            console.error('Error generating payslip image:', error);
            toast.error('Error generating payslip image');
        }
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        }).format(amount);
    };

    const getAttendanceColor = (percentage) => {
        if (percentage >= 95) return 'success';
        if (percentage >= 85) return 'warning';
        return 'danger';
    };

    const calculateTotalPayroll = () => {
        return salarySheet.reduce((sum, emp) => sum + emp.net_salary, 0);
    };

    return (
        <div className="dc-haslayout dc-dbsectionspace">
            <div className="container-fluid py-3">
                <div className="card mb-5">
                    <div className="card-body">
                        <div className="align-items-center justify-content-between mb-3">
                            <div className="d-flex align-items-center gap-2 mb-2">
                                <h5 className="mb-0 font-weight-bold mr-3">Salary Sheet Preparation</h5>
                                <Badge bg="info">HRM System</Badge>
                            </div>
                            <div className="d-flex justify-content-between align-items-center" style={{ gap: 12 }}>
                                <Form.Select
                                    value={selectedMonth}
                                    onChange={(e) => setSelectedMonth(e.target.value)}
                                    style={{ maxWidth: 200 }}
                                >
                                    {months.map(month => (
                                        <option key={month.value} value={month.value}>
                                            {month.label}
                                        </option>
                                    ))}
                                </Form.Select>
                                <div className="d-flex align-items-center gap-2">
                                    <Button
                                        variant="primary"
                                        onClick={generateSalarySheet}
                                        disabled={generating || employeeList.length === 0}
                                    >
                                        {generating ? (
                                            <>
                                                <Spinner animation="border" size="sm" className="me-2" />
                                                Generating...
                                            </>
                                        ) : (
                                            'Generate Salary Sheet'
                                        )}
                                    </Button>
                                    {salarySheet.length > 0 && (
                                        <>
                                            <Button
                                                variant="warning"
                                                onClick={saveSalarySheetToDatabase}
                                                disabled={savingToDatabase}
                                            >
                                                {savingToDatabase ? (
                                                    <>
                                                        <Spinner animation="border" size="sm" className="me-2" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    'Save to Database'
                                                )}
                                            </Button>
                                            <Button variant="success" onClick={exportSalarySheet}>
                                                Export CSV
                                            </Button>
                                        </>
                                    )}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Summary Cards */}
                <Row className="mb-4">
                    <Col md={3}>
                        <Card className="text-center" style={{ height: '100%' }}>
                            <Card.Body>
                                <h3 className="text-primary">{employeeList.length}</h3>
                                <p className="mb-0">Total Employees</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center" style={{ height: '100%' }}>
                            <Card.Body>
                                <h3 className="text-success">{salarySheet.length}</h3>
                                <p className="mb-0">Generated Records</p>
                                <small className="text-muted">
                                    {existingSalaryRecords.length} existing in DB
                                </small>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center" style={{ height: '100%' }}>
                            <Card.Body>
                                <h3 className="text-info">
                                    {formatCurrency(calculateTotalPayroll())}
                                </h3>
                                <p className="mb-0">Total Payroll</p>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={3}>
                        <Card className="text-center" style={{ height: '100%' }}>
                            <Card.Body>
                                <h3 className="text-warning">
                                    {salarySheet.length > 0 ?
                                        (salarySheet.reduce((sum, emp) => sum + parseFloat(emp.attendance.attendancePercentage), 0) / salarySheet.length).toFixed(1)
                                        : 0}%
                                </h3>
                                <p className="mb-0">Avg Attendance</p>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {/* Existing Salary Records */}
                {existingSalaryRecords.length > 0 && (
                    <div className="card mb-4">
                        <div className="card-header">
                            <h6 className="mb-0">Existing Salary Records - {months.find(m => m.value === selectedMonth)?.label}</h6>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table hover size="sm" className="mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Amount</th>
                                            <th>Transfer Method</th>
                                            <th>Status</th>
                                            <th>Reference</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {existingSalaryRecords.map((record, index) => (
                                            <tr key={record.id}>
                                                <td>
                                                    <div className="d-flex align-items-center" style={{ display: 'flex', alignContent: 'center', justifyContent: 'center', alignItems: 'center' }}>
                                                        <ImageShow
                                                            url={record.employee?.[0]?.staff?.[0]?.profile_photo_url}
                                                            width={50}
                                                            height={40}
                                                            style={{
                                                                borderRadius: '50%',
                                                                marginRight: '10px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        <div>
                                                            <div className="fw-bold" style={{ height: '20px' }}>
                                                                {record.employee?.[0]?.staff?.[0]?.first_name} {record.employee?.[0]?.staff?.[0]?.last_name}
                                                            </div>
                                                            <small className="text-muted">
                                                                ID: {record.employee?.[0]?.employee_id}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-success">
                                                        {formatCurrency(record.amount)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="badge bg-info text-capitalize">
                                                        {record.transfer_method === 'salary_sheet_generated'
                                                            ? 'Salary Sheet Generated'
                                                            : record.transfer_method?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                                                        }
                                                    </span>
                                                </td>
                                                <td>
                                                    <Badge bg={
                                                        record.status === 'paid' ? 'success' :
                                                            record.status === 'pending' ? 'warning' : 'danger'
                                                    }>
                                                        {record.status.charAt(0).toUpperCase() + record.status.slice(1)}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <small className="text-muted">
                                                        {record.reference_number}
                                                    </small>
                                                </td>
                                                <td>
                                                    <div className="d-flex justify-content-center align-items-center" style={{ gap: 10 }}>
                                                        <Button
                                                            variant="primary"
                                                            size="sm"
                                                            style={{ padding: '-0.25rem 0.75rem' }}
                                                            onClick={() => handleViewRecord(record)}
                                                        >
                                                            View
                                                        </Button>
                                                        <Button
                                                            variant="warning"
                                                            size="sm"
                                                            onClick={() => handleEditRecord(record)}
                                                        >
                                                            Edit
                                                        </Button>
                                                        <Button
                                                            variant="success"
                                                            size="sm"
                                                            style={{ padding: '0.25rem 0.75rem' }}
                                                            onClick={() => handlePayRecord(record)}
                                                            disabled={record.status === 'paid'}
                                                        >
                                                            {record.status === 'paid' ? 'Paid' : 'Pay'}
                                                        </Button>
                                                        <Button
                                                            variant="info"
                                                            size="sm"
                                                            style={{ padding: '0.25rem 0.75rem' }}
                                                            onClick={() => handlePaySlip(record)}
                                                            disabled={generatingPayslip}
                                                        >
                                                            {generatingPayslip ? '...' : 'Pay Slip'}
                                                        </Button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )}



                {showPreview && salarySheet.length > 0 && (
                    <div className="card">
                        <div className="card-header d-flex justify-content-between align-items-center">
                            <h6 className="mb-0">Salary Sheet Preview - {months.find(m => m.value === selectedMonth)?.label}</h6>
                            <Button variant="outline-secondary" size="sm" onClick={() => setShowPreview(false)}>
                                Hide Preview
                            </Button>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table hover size="sm" className="mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>Employee</th>
                                            <th>Department</th>
                                            <th>Base Salary</th>
                                            <th>Allowances</th>
                                            <th>Overtime</th>
                                            <th>Total Earnings</th>
                                            <th>Deductions</th>
                                            <th>Net Salary</th>
                                            <th>Attendance</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {salarySheet.map((employee, index) => (
                                            <tr key={employee.employee_id}>
                                                <td>
                                                    <div className="d-flex align-items-center">
                                                        <ImageShow
                                                            url={employee.profile_photo_url}
                                                            style={{
                                                                width: '40px',
                                                                height: '40px',
                                                                marginRight: '10px',
                                                                borderRadius: '50%',
                                                                marginRight: '10px',
                                                                objectFit: 'cover'
                                                            }}
                                                        />
                                                        <div>
                                                            <div className="fw-bold">
                                                                {employee.employee_name}
                                                            </div>
                                                            <small className="text-muted">
                                                                {employee.employee_code}
                                                            </small>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="badge bg-light text-dark">
                                                        {employee.department}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold">
                                                        {formatCurrency(employee.base_salary)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-info">
                                                        {formatCurrency(employee.allowances)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-warning">
                                                        {formatCurrency(employee.overtime_pay)}
                                                    </span>
                                                    <div className="small text-muted">
                                                        {employee.overtime_hours}h
                                                    </div>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-success">
                                                        {formatCurrency(employee.total_earnings)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-danger">
                                                        {formatCurrency(employee.deductions)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <span className="fw-bold text-primary">
                                                        {formatCurrency(employee.net_salary)}
                                                    </span>
                                                </td>
                                                <td>
                                                    <div>
                                                        <Badge bg={getAttendanceColor(employee.attendance.attendancePercentage)}>
                                                            {employee.attendance.attendancePercentage}%
                                                        </Badge>
                                                        <div className="small text-muted mt-1">
                                                            {employee.attendance.presentDays} days
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )}

                {!showPreview && employeeList.length === 0 && (
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <Alert variant="info">
                                <h5>No Employees Found</h5>
                                <p className="mb-0">Please add employees first before generating salary sheets.</p>
                            </Alert>
                        </div>
                    </div>
                )}

                {!showPreview && salarySheet.length === 0 && (
                    <div className="card">
                        <div className="card-body text-center py-5">
                            <Alert variant="info">
                                <h5>No Salary Sheet Found</h5>
                                <p className="mb-0">Please generate salary sheet first before saving to database.</p>
                            </Alert>
                        </div>
                    </div>
                )}

                {/* View Details Modal */}
                <Modal show={showViewModal} onHide={() => setShowViewModal(false)} size="lg" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Salary Record Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedRecord && (
                            <div>
                                <Row className="mb-3">
                                    <Col md={6}>
                                        <div className="d-flex align-items-center mb-3">
                                            <ImageShow
                                                url={selectedRecord.employee?.[0]?.staff?.[0]?.profile_photo_url}
                                                width={60}
                                                height={60}
                                                style={{
                                                    borderRadius: '50%',
                                                    marginRight: '15px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div>
                                                <h5 className="mb-1">
                                                    {selectedRecord.employee?.[0]?.staff?.[0]?.first_name} {selectedRecord.employee?.[0]?.staff?.[0]?.last_name}
                                                </h5>
                                                <p className="text-muted mb-0">
                                                    ID: {selectedRecord.employee?.[0]?.employee_id}
                                                </p>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <div className="text-end">
                                            <h4 className="text-success mb-0">
                                                {formatCurrency(selectedRecord.amount)}
                                            </h4>
                                            <Badge bg={
                                                selectedRecord.status === 'paid' ? 'success' :
                                                    selectedRecord.status === 'pending' ? 'warning' : 'danger'
                                            }>
                                                {selectedRecord.status.charAt(0).toUpperCase() + selectedRecord.status.slice(1)}
                                            </Badge>
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col md={6}>
                                        <h6>Payment Details</h6>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td><strong>Month/Year:</strong></td>
                                                    <td>{selectedRecord.month} {selectedRecord.year}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Transfer Method:</strong></td>
                                                    <td>
                                                        <span className="badge bg-info">
                                                            {selectedRecord.transfer_method === 'salary_sheet_generated'
                                                                ? 'Salary Sheet Generated'
                                                                : selectedRecord.transfer_method?.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
                                                            }
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Reference:</strong></td>
                                                    <td>{selectedRecord.reference_number}</td>
                                                </tr>
                                                <tr>
                                                    <td><strong>Created:</strong></td>
                                                    <td>{new Date(selectedRecord.created_at).toLocaleDateString()}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </Col>
                                    <Col md={6}>
                                        <h6>Additional Information</h6>
                                        <div className="border p-3 rounded" style={{ minHeight: '150px' }}>
                                            <p className="mb-0">
                                                {selectedRecord.notes || 'No additional notes available.'}
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowViewModal(false)}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Edit/Approve Modal */}
                <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Edit Salary Record</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedRecord && (
                            <div>
                                <div className="mb-3">
                                    <h6>Employee: {selectedRecord.employee?.[0]?.staff?.[0]?.first_name} {selectedRecord.employee?.[0]?.staff?.[0]?.last_name}</h6>
                                    <p className="text-muted">Amount: {formatCurrency(selectedRecord.amount)}</p>
                                </div>

                                <Form.Group className="mb-3">
                                    <Form.Label>Status *</Form.Label>
                                    <Form.Select
                                        value={editStatus}
                                        onChange={(e) => setEditStatus(e.target.value)}
                                    >
                                        <option value="pending">Pending</option>
                                        <option value="approved">Approved</option>
                                        <option value="rejected">Rejected</option>
                                        <option value="paid">Paid</option>
                                        <option value="cancelled">Cancelled</option>
                                    </Form.Select>
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label>Notes</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={4}
                                        value={editNotes}
                                        onChange={(e) => setEditNotes(e.target.value)}
                                        placeholder="Add notes about this salary record..."
                                    />
                                </Form.Group>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleUpdateRecord}>
                            Update Record
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Payment Modal */}
                <Modal show={showPayModal} onHide={() => setShowPayModal(false)} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Process Payment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedRecord && (
                            <div>
                                <div className="mb-3">
                                    <h6>Employee: {selectedRecord.employee?.[0]?.staff?.[0]?.first_name} {selectedRecord.employee?.[0]?.staff?.[0]?.last_name}</h6>
                                    <h4 className="text-success">Amount: {formatCurrency(selectedRecord.amount)}</h4>
                                </div>

                                <Form.Group className="mb-3">
                                    <Form.Label>Payment Method *</Form.Label>
                                    <Form.Select
                                        value={paymentMethod}
                                        onChange={(e) => setPaymentMethod(e.target.value)}
                                    >
                                        <option value="">Select payment method...</option>
                                        <option value="cash">Cash Payment</option>
                                        <option value="bank_transfer">Bank Transfer</option>
                                        <option value="upi">UPI Payment</option>
                                        <option value="check">Check Payment</option>
                                        <option value="online">Online Payment</option>
                                    </Form.Select>
                                </Form.Group>

                                {paymentMethod && paymentMethod !== 'cash' && (
                                    <Form.Group className="mb-3">
                                        <Form.Label>Reference Number *</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={paymentReference}
                                            onChange={(e) => setPaymentReference(e.target.value)}
                                            placeholder={
                                                paymentMethod === 'upi' ? 'UPI Transaction ID' :
                                                    paymentMethod === 'bank_transfer' ? 'Bank Transaction Reference' :
                                                        paymentMethod === 'check' ? 'Check Number' :
                                                            paymentMethod === 'online' ? 'Online Payment Reference' :
                                                                'Reference Number'
                                            }
                                        />
                                    </Form.Group>
                                )}

                                <Alert variant="info">
                                    <strong>Payment Confirmation:</strong><br />
                                    This will mark the salary as paid and update the payment details.
                                    Make sure you have processed the actual payment before confirming.
                                </Alert>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowPayModal(false)}>
                            Cancel
                        </Button>
                        <Button
                            variant="success"
                            onClick={handleProcessPayment}
                            disabled={processingPayment || !paymentMethod}
                        >
                            {processingPayment ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Processing...
                                </>
                            ) : (
                                'Confirm Payment'
                            )}
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Payslip Preview Modal */}
                <Modal show={showPayslipModal} onHide={() => setShowPayslipModal(false)} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Payslip Preview</Modal.Title>
                    </Modal.Header>
                    <Modal.Body id="payslip-content">
                        {payslipData && (
                            <div>
                                {/* Company Header */}
                                <div className="text-center border-bottom pb-3 mb-4">
                                    <h3 className="text-primary mb-1">MEDDY LIST</h3>
                                    <h5 className="text-muted">PAYSLIP</h5>
                                </div>

                                {/* Employee and Period Info */}
                                <Row className="mb-4">
                                    <Col md={6}>
                                        <h6 className="text-primary">Employee Information</h6>
                                        <div className="d-flex align-items-center mb-3">
                                            <ImageShow
                                                url={payslipData.employee.profile_photo}
                                                width={50}
                                                height={50}
                                                style={{
                                                    borderRadius: '50%',
                                                    marginRight: '15px',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                            <div>
                                                <h6 className="mb-1">{payslipData.employee.name}</h6>
                                                <small className="text-muted">ID: {payslipData.employee.id}</small>
                                            </div>
                                        </div>
                                        <div className="small">
                                            <div><strong>Department:</strong> {payslipData.employee.department}</div>
                                            <div><strong>Designation:</strong> {payslipData.employee.designation}</div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <h6 className="text-primary">Pay Period</h6>
                                        <div className="small">
                                            <div><strong>Month:</strong> {payslipData.period.monthName}</div>
                                            <div><strong>Year:</strong> {payslipData.period.year}</div>
                                            <div><strong>Generated:</strong> {payslipData.generatedDate}</div>
                                        </div>
                                    </Col>
                                </Row>

                                {/* Salary Details */}
                                <div className="mb-4">
                                    <h6 className="text-primary">Salary Details</h6>
                                    <Table size="sm" className="mb-0">
                                        <tbody>
                                            <tr>
                                                <td><strong>Basic Salary</strong></td>
                                                <td className="text-end">{formatCurrency(payslipData.salary.basic)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Allowances</strong></td>
                                                <td className="text-end">{formatCurrency(payslipData.salary.allowances)}</td>
                                            </tr>
                                            <tr>
                                                <td><strong>Overtime Pay</strong></td>
                                                <td className="text-end">{formatCurrency(payslipData.salary.overtime)}</td>
                                            </tr>
                                            <tr className="table-success">
                                                <td><strong>Total Earnings</strong></td>
                                                <td className="text-end"><strong>{formatCurrency(payslipData.salary.totalEarnings)}</strong></td>
                                            </tr>
                                            <tr>
                                                <td><strong>Deductions</strong></td>
                                                <td className="text-end text-danger">{formatCurrency(payslipData.salary.deductions)}</td>
                                            </tr>
                                            <tr className="table-primary">
                                                <td><strong>Net Salary</strong></td>
                                                <td className="text-end"><strong>{formatCurrency(payslipData.salary.netSalary)}</strong></td>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Attendance and Payment Info */}
                                <Row>
                                    <Col md={6}>
                                        <h6 className="text-primary">Attendance Summary</h6>
                                        <div className="small">
                                            <div><strong>Present Days:</strong> {payslipData.attendance.presentDays}</div>
                                            <div><strong>Absent Days:</strong> {payslipData.attendance.absentDays}</div>
                                            <div><strong>Total Working Days:</strong> {payslipData.attendance.totalWorkingDays}</div>
                                            <div><strong>Attendance %:</strong>
                                                <Badge bg={getAttendanceColor(payslipData.attendance.attendancePercentage)} className="ms-2">
                                                    {payslipData.attendance.attendancePercentage}%
                                                </Badge>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col md={6}>
                                        <h6 className="text-primary">Payment Information</h6>
                                        <div className="small">
                                            <div><strong>Status:</strong>
                                                <Badge bg={
                                                    payslipData.payment.status === 'paid' ? 'success' :
                                                        payslipData.payment.status === 'pending' ? 'warning' : 'danger'
                                                } className="ms-2">
                                                    {payslipData.payment.status.toUpperCase()}
                                                </Badge>
                                            </div>
                                            <div><strong>Method:</strong> {payslipData.payment.method.replace(/_/g, ' ').toUpperCase()}</div>
                                            <div><strong>Reference:</strong> {payslipData.payment.reference}</div>
                                            {payslipData.payment.paidDate && (
                                                <div><strong>Paid Date:</strong> {payslipData.payment.paidDate}</div>
                                            )}
                                        </div>
                                    </Col>
                                </Row>

                                {/* Footer */}
                                <div className="text-center mt-4 pt-3 border-top">
                                    <small className="text-muted">
                                        This is a computer generated payslip. No signature required.<br />
                                        Generated on {payslipData.generatedDate} at {payslipData.generatedTime}
                                    </small>
                                </div>
                            </div>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => setShowPayslipModal(false)}>
                            Close
                        </Button>
                        <Button variant="success" onClick={downloadPayslipPDF}>
                            Download as Image
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </div>
    );
};

export default SalarySheetPreparation;
